import * as queryString from 'query-string';
import { assign } from 'lodash';
import API from '../api';
import * as actions from '../constants';
import generateActions from './baseAction';

const {
  showError,
  clearErrors,
  getReservations,
  getReservation,
  addReservation,
  updateReservation,
  removeReservation,
} = generateActions('reservation', 'reservations');

/**
 * Get a list of reservations in a range
 * @param {Date} start
 * @param {Date} end
 */
const getReservationRange = (start, end): any => (dispatch) => {
  dispatch({ start, end, type: actions.REQUEST_RESERVATION_RANGE });
  return API.request(
    `/reservations/range?${queryString.stringify({
      start,
      end,
    })}`,
  )
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_RESERVATION_RANGE,
        data: response,
      });
      return response;
    })
    .catch((err) => {
      dispatch({
        type: actions.RECEIVE_RESERVATION_RANGE,
        error: 'There was a problem fetching reservations',
      });
      return false;
    });
};

/**
 * Re-assign a reservation's provisional vehicle
 * @param {Number} id
 * @param {Number} provisionalVehicle
 */
const setReservationProvisionalVehicle = (
  id: number,
  provisionalVehicle: number,
) => (dispatch) => {
  dispatch({ id, type: actions.REQUEST_RESERVATION_SET_PROVISIONAL_VEHICLE });
  return API.request(`/reservations/${id}/provisional`, 'POST', {
    provisional_vehicle_id: provisionalVehicle,
  })
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_RESERVATION_SET_PROVISIONAL_VEHICLE,
        data: response,
      });
      return response;
    })
    .catch((err) => {
      dispatch({
        type: actions.RECEIVE_RESERVATION_SET_PROVISIONAL_VEHICLE,
        error:
          "There was a problem setting the reservation's provisional vehicle",
      });
      return false;
    });
};

export {
  showError,
  clearErrors,
  getReservations,
  getReservation,
  addReservation,
  updateReservation,
  removeReservation,
  getReservationRange,
  setReservationProvisionalVehicle,
};
